import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AiHelperRoutingModule } from './ai-helper-routing.module';
import { AiHelperComponent } from './ai-helper.component';
import { AiHelperService } from './ai-helper.service';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		AiHelperRoutingModule,
	],
	declarations: [
		AiHelperComponent,
	],
	providers: [
		AiHelperService,
	]
})
export class AiHelperModule { }
